import React, { useEffect, useState } from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'

// images
import hero from "./Images/hero.svg";


// icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";

import BoardofDirectors from './BoardofDirectors';
import axios from 'axios';

interface banner{
  title:string,
  content:string,
  id:number,
  image:string,
  pageName:String,
}

const Leadership = () => {
  const[bannerdata, setBannerdata] = useState<banner[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/directorbanner",{
            
      });

        console.log('banner data',response.data)
        setBannerdata(response.data);
        console.log("banner data in a array",bannerdata);
      } catch (error) {
        console.error("banner Not Found:", error);
      }
    };
    fetchData();
  }, []);

    return (
        <div>
            <Header/>
            {bannerdata.map((items)=>(
 <div
 className="w-full h-[451px] relative"
 style={{
   backgroundImage: `url(https://rmbbackend.rmbjaipur.com/${items.image.replace(/\\/g, '/')})`,
   backgroundPosition: "center",
   backgroundSize: "cover",
 }}
>
 {/* <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div> */}
 <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
   <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
   {items.title}
   </h2>
   <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
   {items.content}
   </p>
   <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
     <a
       className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
       href="/"
     >
       {" "}
       <FaHome />
       Home
     </a>
     <a
       className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
       href="/directors"
     >
       {" "}
       <IoIosArrowForward />
       Directors            </a>
   
   </div>
 </div>
</div>
            ))}
           
        <BoardofDirectors/>
            <Footer/>
        </div>
      )
}

export default Leadership